import { render, staticRenderFns } from "./StripeLogosHeader.vue?vue&type=template&id=747c00ff&scoped=true&"
import script from "./StripeLogosHeader.vue?vue&type=script&lang=js&"
export * from "./StripeLogosHeader.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "747c00ff",
  null
  
)

export default component.exports